import React, { useState, useCallback, useEffect } from "react";
import {
  Box,
  Dialog,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";

import { useStyles } from "./styled";

import g01 from "../../../assets/image/qcv-gallery/ceremony-01.jpg";
import g02 from "../../../assets/image/qcv-gallery/ceremony-02.jpg";
import g03 from "../../../assets/image/qcv-gallery/ceremony-03.jpg";
import g04 from "../../../assets/image/qcv-gallery/ceremony-04.jpg";
import g05 from "../../../assets/image/qcv-gallery/ceremony-05.jpg";
import g06 from "../../../assets/image/qcv-gallery/ceremony-06.jpg";
import g07 from "../../../assets/image/qcv-gallery/ceremony-07.jpg";
import g08 from "../../../assets/image/qcv-gallery/ceremony-08.jpg";
import g09 from "../../../assets/image/qcv-gallery/ceremony-09.jpg";
import g10 from "../../../assets/image/qcv-gallery/ceremony-10.jpg";
import g11 from "../../../assets/image/qcv-gallery/ceremony-11.jpg";
import g12 from "../../../assets/image/qcv-gallery/ceremony-12.jpg";
import g13 from "../../../assets/image/qcv-gallery/ceremony-13.jpg";
import g14 from "../../../assets/image/qcv-gallery/ceremony-14.png";
import g15 from "../../../assets/image/qcv-gallery/ceremony-15.png";
import g16 from "../../../assets/image/qcv-gallery/ceremony-16.jpg";
import g17 from "../../../assets/image/qcv-gallery/ceremony-17.jpg";
import g18 from "../../../assets/image/qcv-gallery/ceremony-18.jpg";
import g19 from "../../../assets/image/qcv-gallery/ceremony-19.jpg";
import g19_1 from "../../../assets/image/qcv-gallery/ceremony-19-1.jpg";
import g19_2 from "../../../assets/image/qcv-gallery/ceremony-19-2.jpg";
import g20 from "../../../assets/image/qcv-gallery/ceremony-20.jpg";
import g21 from "../../../assets/image/qcv-gallery/ceremony-21.jpg";
import g21_1 from "../../../assets/image/qcv-gallery/ceremony-21-1.jpg";
import g22 from "../../../assets/image/qcv-gallery/ceremony-22.jpg";
import g23 from "../../../assets/image/qcv-gallery/ceremony-23.jpg";
import gTd1 from "../../../assets/image/qcv-gallery/ceremony-toadam-2023-1.jpg";
import gTd2 from "../../../assets/image/qcv-gallery/ceremony-toadam-2023-2.jpg";

// Ảnh lễ trao giải theo đúng thứ tự đánh số (19-1, 19-2 ngay sau 19; 21-1 ngay sau 21),
// kèm chú thích từng ảnh. Thêm/bớt ảnh: copy file vào assets/image/qcv-gallery rồi khai
// báo thêm phần tử (giữ đúng vị trí thứ tự).
const GALLERY = [
  { id: "01", src: g01, caption: "Thủ tướng Chính phủ Phan Văn Khải chụp ảnh lưu niệm cùng các cá nhân đạt Giải thưởng Công nghệ thông tin Thanh niên mang tên Quả Cầu Vàng năm 2003" },
  { id: "02", src: g02, caption: "Phó Thủ tướng Chính phủ Phạm Gia Khiêm và Bí thư thứ nhất Trung ương Đoàn Hoàng Bình Quân chụp ảnh lưu niệm cùng 10 cá nhân đạt Giải thưởng Công nghệ thông tin Thanh niên mang tên Quả Cầu Vàng năm 2004" },
  { id: "03", src: g03, caption: "Phó Thủ tướng Chính phủ Phạm Gia Khiêm và Bí thư thứ nhất Trung ương Đoàn Đào Ngọc Dung chụp ảnh lưu niệm cùng 10 cá nhân đạt Giải thưởng Công nghệ thông tin Thanh niên mang tên Quả Cầu Vàng năm 2005" },
  { id: "04", src: g04, caption: "Phó Thủ tướng Chính phủ Nguyễn Thiện Nhân và Bí thư thứ nhất Trung ương Đoàn Võ Văn Thưởng trao thưởng cho các cá nhân đạt Giải thưởng Công nghệ thông tin Thanh niên mang tên Quả Cầu Vàng năm 2008" },
  { id: "05", src: g05, caption: "Phó Thủ tướng Chính phủ Nguyễn Thiện Nhân chụp ảnh lưu niệm cùng cá nhân đạt Giải thưởng Công nghệ thông tin Thanh niên mang tên Quả Cầu Vàng năm 2009" },
  { id: "06", src: g06, caption: "Phó Thủ tướng Chính phủ Nguyễn Thiện Nhân chụp ảnh lưu niệm cùng cá nhân đạt Giải thưởng Công nghệ thông tin Thanh niên mang tên Quả Cầu Vàng năm 2010" },
  { id: "07", src: g07, caption: "Phó Thủ tướng Chính phủ Nguyễn Thiện Nhân trao thưởng cho các cá nhân đạt Giải thưởng Khoa học kỹ thuật Thanh niên mang tên Quả Cầu Vàng năm 2011" },
  { id: "08", src: g08, caption: "Phó Thủ tướng Chính phủ Nguyễn Thiện Nhân và Bí thư thứ nhất Trung ương Đoàn Nguyễn Đắc Vinh chụp ảnh lưu niệm cùng các cá nhân đạt Giải thưởng Khoa học kỹ thuật Thanh niên mang tên Quả Cầu Vàng năm 2012" },
  { id: "09", src: g09, caption: "Bí thư thứ nhất Trung ương Đoàn Nguyễn Đắc Vinh và Bộ trưởng Bộ Khoa học và Công nghệ Nguyễn Quân trao Giải thưởng cho các cá nhân xuất sắc đạt Giải thưởng Khoa học kỹ thuật Thanh niên mang tên Quả Cầu Vàng năm 2013" },
  { id: "10", src: g10, caption: "Bí thư Trung ương Đoàn Lê Quốc Phong trao Giải thưởng cho các cá nhân xuất sắc đạt Giải thưởng Khoa học kỹ thuật Thanh niên mang tên Quả Cầu Vàng năm 2014" },
  { id: "11", src: g11, caption: "Bí thư Trung ương Đoàn Lê Quốc Phong gắn Huy hiệu Tuổi trẻ sáng tạo cho các cá nhân xuất sắc đạt Giải thưởng Khoa học kỹ thuật Thanh niên mang tên Quả Cầu Vàng năm 2015" },
  { id: "12", src: g12, caption: "Phó Chủ tịch nước Đặng Thị Ngọc Thịnh chụp ảnh lưu niệm cùng các cá nhân đạt Giải thưởng Khoa học công nghệ Thanh niên Quả Cầu Vàng năm 2016" },
  { id: "13", src: g13, caption: "Phó Chủ tịch thường trực Quốc hội Tòng Thị Phóng và Bí thư Trung ương Đoàn Nguyễn Anh Tuấn gặp gỡ các cá nhân đạt Giải thưởng Khoa học công nghệ Thanh niên Quả Cầu Vàng năm 2017" },
  { id: "14", src: g14, caption: "Ủy viên Bộ Chính trị, Bí thư Thành ủy TP. Hồ Chí Minh Nguyễn Thiện Nhân và Bí thư thứ nhất Trung ương Đoàn Lê Quốc Phong chụp ảnh lưu niệm cùng các cá nhân đạt Giải thưởng Khoa học công nghệ Thanh niên Quả Cầu Vàng năm 2018" },
  { id: "15", src: g15, caption: "Bí thư thứ nhất Trung ương Đoàn Lê Quốc Phong trao giải thưởng cho các cá nhân đạt Giải thưởng Khoa học công nghệ Thanh niên Quả Cầu Vàng năm 2019" },
  { id: "16", src: g16, caption: "Bí thư Thường trực Trung ương Đoàn Bùi Quang Huy trao giải thưởng cho các cá nhân đạt Giải thưởng Khoa học công nghệ Thanh niên Quả Cầu Vàng năm 2020" },
  { id: "17", src: g17, caption: "Bí thư Thường trực Trung ương Đoàn Bùi Quang Huy trao giải thưởng cho các cá nhân đạt Giải thưởng Khoa học công nghệ Quả Cầu Vàng năm 2021" },
  { id: "18", src: g18, caption: "Phó Trưởng ban Thường trực Ban Dân vận Trung ương Phạm Tất Thắng và Bí thư thứ nhất Trung ương Đoàn Bùi Quang Huy trao giải thưởng cho 10 cá nhân đạt Giải thưởng Khoa học công nghệ Quả Cầu Vàng năm 2022" },
  { id: "19", src: g19, caption: "Phó Chủ tịch nước Võ Thị Ánh Xuân và Bí thư thứ nhất Trung ương Đoàn Bùi Quang Huy trao thưởng cho các cá nhân đạt Giải thưởng Khoa học công nghệ Quả Cầu Vàng năm 2023" },
  { id: "19-1", src: g19_1, caption: "Phó Chủ tịch nước Võ Thị Ánh Xuân và Bí thư thứ nhất Trung ương Đoàn Bùi Quang Huy trao giải thưởng cho các cá nhân đạt Giải thưởng Khoa học công nghệ Quả Cầu Vàng năm 2023" },
  { id: "19-2", src: g19_2, caption: "Phó Chủ tịch nước Võ Thị Ánh Xuân và Bí thư thứ nhất Trung ương Đoàn Bùi Quang Huy trao giải thưởng cho các cá nhân đạt Giải thưởng Khoa học công nghệ Quả Cầu Vàng năm 2023" },
  { id: "19-3", src: gTd1, caption: "Đồng chí Nguyễn Minh Triết, Bí thư Trung ương Đoàn phát biểu tại tọa đàm 20 năm Giải thưởng KHCN Quả Cầu Vàng năm 2023" },
  { id: "19-4", src: gTd2, caption: "Các tài năng trẻ đạt Giải thưởng KHCN Quả Cầu Vàng chụp ảnh lưu niệm tại Tọa đàm 20 năm Giải thưởng năm 2023" },
  { id: "20", src: g20, caption: "Bí thư Trung ương Đoàn Nguyễn Minh Triết và Thứ trưởng Bộ Khoa học và Công nghệ Bùi Thế Duy trao thưởng cho các cá nhân đạt Giải thưởng Khoa học công nghệ Quả Cầu Vàng năm 2024" },
  { id: "21", src: g21, caption: "Ủy viên Bộ Chính trị, Chủ tịch Ủy ban Trung ương Mặt trận Tổ quốc Việt Nam Đỗ Văn Chiến và Bí thư thứ nhất Trung ương Đoàn Bùi Quang Huy trao thưởng cho các cá nhân đạt Giải thưởng Khoa học công nghệ Quả Cầu Vàng năm 2025" },
  { id: "21-1", src: g21_1, caption: "Phó Chủ tịch nước Võ Thị Ánh Xuân phát biểu tại Lễ trao Giải thưởng Khoa học công nghệ Quả Cầu Vàng năm 2025" },
  { id: "22", src: g22, caption: "Các tài năng trẻ đạt Giải thưởng Khoa học công nghệ Quả Cầu Vàng và Giải thưởng Nữ sinh khoa học công nghệ Việt Nam năm 2025 dâng hoa và vào lăng viếng Chủ tịch Hồ Chí Minh" },
  { id: "23", src: g23, caption: "Bí thư Trung ương Đoàn Nguyễn Minh Triết chụp ảnh lưu niệm cùng các cá nhân đạt Giải thưởng Khoa học công nghệ Quả Cầu Vàng năm 2025" },
];

// Ảnh tiêu biểu hiển thị ở hàng trên (kích cỡ to), theo đúng thứ tự yêu cầu.
const FEATURED_IDS = ["19", "19-1", "19-2", "19-3", "21-1"];

// Gắn index toàn cục để lightbox điều hướng xuyên suốt toàn bộ gallery.
const INDEXED = GALLERY.map((item, index) => ({ ...item, index }));
const FEATURED = FEATURED_IDS.map((id) =>
  INDEXED.find((item) => item.id === id)
).filter(Boolean);
const REST = INDEXED.filter((item) => !FEATURED_IDS.includes(item.id));

// Một hàng ảnh tự chạy (auto slideshow) liên tục, tạm dừng khi di chuột.
// Nhân đôi danh sách để cuộn vòng lặp mượt (translateX(-50%)).
function MarqueeRow({ items, itemClass, imageClass, durationSec, onOpen }) {
  const classes = useStyles();
  const loop = [...items, ...items];
  return (
    <Box className={classes.marquee}>
      <Box
        className={classes.track}
        style={{ animationDuration: `${durationSec}s` }}
      >
        {loop.map((item, i) => (
          <Box
            key={`${item.id}-${i}`}
            className={`${classes.item} ${itemClass}`}
            onClick={() => onOpen(item.index)}
            title={item.caption}
            aria-hidden={i >= items.length ? true : undefined}
          >
            <img
              src={item.src}
              alt={item.caption || `Lễ trao giải Quả Cầu Vàng ${item.id}`}
              loading="lazy"
              className={`${classes.image} ${imageClass}`}
            />
            <Box className={classes.overlay}>
              <span className={classes.zoomHint}>Xem ảnh</span>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default function CeremonyGallery() {
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));
  const [openIndex, setOpenIndex] = useState(-1);

  const isOpen = openIndex >= 0;
  const open = useCallback((index) => setOpenIndex(index), []);
  const close = useCallback(() => setOpenIndex(-1), []);
  const prev = useCallback(
    () => setOpenIndex((i) => (i <= 0 ? GALLERY.length - 1 : i - 1)),
    []
  );
  const next = useCallback(
    () => setOpenIndex((i) => (i >= GALLERY.length - 1 ? 0 : i + 1)),
    []
  );

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => {
      if (e.key === "ArrowLeft") prev();
      else if (e.key === "ArrowRight") next();
      else if (e.key === "Escape") close();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isOpen, prev, next, close]);

  return (
    <>
      <Box className={classes.gallery}>
        <Box>
          <Typography className={classes.rowTitle}>
            Khoảnh khắc tiêu biểu
          </Typography>
          <MarqueeRow
            items={FEATURED}
            itemClass={classes.itemLarge}
            imageClass={classes.imageLarge}
            durationSec={45}
            onOpen={open}
          />
        </Box>
        <Box>
          <Typography className={classes.rowTitle}>
            Các khoảnh khắc khác qua các năm
          </Typography>
          <MarqueeRow
            items={REST}
            itemClass={classes.itemSmall}
            imageClass={classes.imageSmall}
            durationSec={110}
            onOpen={open}
          />
        </Box>
      </Box>

      <Dialog
        open={isOpen}
        onClose={close}
        maxWidth="lg"
        fullScreen={fullScreen}
        PaperProps={{ className: classes.lightboxPaper }}
      >
        <IconButton className={classes.closeBtn} onClick={close} aria-label="Đóng">
          <CloseIcon />
        </IconButton>
        <IconButton
          className={`${classes.navBtn} ${classes.navPrev}`}
          onClick={prev}
          aria-label="Ảnh trước"
        >
          <NavigateBeforeIcon fontSize="large" />
        </IconButton>
        <IconButton
          className={`${classes.navBtn} ${classes.navNext}`}
          onClick={next}
          aria-label="Ảnh sau"
        >
          <NavigateNextIcon fontSize="large" />
        </IconButton>
        {isOpen && (
          <Box className={classes.lightboxContent}>
            <img
              src={GALLERY[openIndex].src}
              alt={GALLERY[openIndex].caption || "Lễ trao giải Quả Cầu Vàng"}
              className={classes.lightboxImage}
            />
            <Box className={classes.lightboxFooter}>
              <Typography variant="body2" className={classes.counter}>
                Ảnh {openIndex + 1} / {GALLERY.length}
              </Typography>
              {GALLERY[openIndex].caption ? (
                <Typography variant="body1" className={classes.caption}>
                  {GALLERY[openIndex].caption}
                </Typography>
              ) : null}
            </Box>
          </Box>
        )}
      </Dialog>
    </>
  );
}
